import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import Form from 'components/Form';
import useId from 'hooks/useId';
import VS from "constants/ValidationShema";
import Loading from "components/Loading";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";
import PartsTable from "components/PartsTable";
import {connect} from "react-redux";
import BoldTypography from "components/BoldTypography";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import PurchasingGroupSectionService from "services/PurchasingGroupSectionService";
import {PurchasingGroupStageSections} from "../../../../constants/PurchasingGroupStageSections";

function AddMemberUserPopup(
    {
        groupId,
        memberId,
        onClose,
        formSubmit,
    }) {

    const [working, setWorking] = useState(false);
    const [membersList, setMembersList] = useState(null);
    const formId = useId();
    const handleSubmit = () => formSubmit[formId]();

    useEffect(() => {
        PurchasingGroupStage1Service.getAvailableMemberUsers(groupId, memberId).then((resp) => {
            const respMapped = resp.map(x => ({identity: "_" + x.identity, name: `${x.firstName} ${x.lastName}`}));
            setMembersList(respMapped);
        }).catch(() => onClose());
        // eslint-disable-next-line
    }, [])


    const onSubmit = ({users}) => {
        const selectedUsers = Object.keys(users).filter(key => !!users[key]).map(key => parseInt(key.substring(1)))
        setWorking(true);
        PurchasingGroupStage1Service.addMemberUser(groupId, memberId, selectedUsers).then((resp) => {
            PurchasingGroupSectionService.getSections(groupId, PurchasingGroupStageSections.MEMBERS)
            onClose();
        }).catch(() => {
            setWorking(false);
        })
    }

    const getActions = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onClose, 'outlined', working));
        buttons.push(createButton(Tr('confirm'), handleSubmit, undefined, working || !membersList || membersList.length === 0, undefined, working));
        return <MultiButton buttons={buttons}/>;
    }

    return (
        <Dialog
            title={Tr("purchasing_group_users_add")}
            open={true}
            dialogActions={getActions()}
        >
            {
                !membersList ? <Loading/> :
                    <Form
                        initialValues={{
                            users: membersList.reduce((prev, cur) => {
                                prev[cur.identity] = false;
                                return prev;
                            }, {}),
                        }}
                        validationSchema={
                            VS.object({
                                users: VS.any().test('partSelected', Tr('choose_at_least_one'), (e) => {
                                    const selected = Object.keys(e).filter(x => e[x] === true).length;
                                    return selected > 0;
                                })
                            })
                        }
                        onSubmit={onSubmit}
                        id={formId}
                    >
                        {(formikProps) => (
                            membersList.length === 0 ?
                                <BoldTypography>{Tr('purchasing_group_users_add_no_users')}</BoldTypography>
                                :
                                <PartsTable
                                    label={Tr('purchasing_group_users_add_label')}
                                    id="users"
                                    formikProps={formikProps}
                                    elementList={membersList}
                                    disabled={working}
                                />)}
                    </Form>
            }

        </Dialog>
    )
}

AddMemberUserPopup.propTypes = {
    groupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func.isRequired
};

export default connect((state) => ({
    formSubmit: state.form
}), {})(AddMemberUserPopup);